<template>
  <SComfortSelection
    :vehicleCategoryId="getVehicleCategoryId"
    :comfortTypeItems="comfortTypeItems"
    @setComfortType="setComfortType"
  />
</template>
<script lang="ts">
export default {
  name: 'ComfortSelection',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { SComfortSelection } from '@slg/web-customer-shared';
import { useStore, useRouteRef } from '@/composables';

const emit = defineEmits(['clearBookingRequestError']);
const store = useStore();
const route = useRouteRef();

const getVehicleCategoryId = computed(() => store.getters['booking/getVehicleCategoryId']);
const getVehicleCategories = computed(() => store.getters['opsZone/getVehicleCategories']);
const comfortTypeItems = computed(() => {
  const availableVehicleTypes = getVehicleCategories.value.map((category: any) => (
    {
      text: category.localizedName[route.value.params.lang]
        || category.localizedName.en
        || category.identifier,
      value: category.vehicleCategoryId,
    }
  ));
  return availableVehicleTypes || [];
});

function setVehicleFeatures(vehicleFeatures: any[], maxSpecialSeatCapacity: number) {
  const selectedFeatures = vehicleFeatures.map((feature) => (
    {
      ...feature,
      amount: 0,
      showIcon: false,
    }
  ));
  if (maxSpecialSeatCapacity) {
    const localizedVehicleFeatureName = {
      en: 'Wheelchair Place',
      fr: 'Fauteuil roulant',
      es: 'Wheelchair Place -es',
      pt: 'Wheelchair Place -pt',
      nl: 'Wheelchair Place -nl',
      de: 'Rollstuhl',
      it: 'Wheelchair Place -it',
    };
    const wheelchairPlace = {
      vehicleFeatureId: 'wheelchairPlace',
      capacity: maxSpecialSeatCapacity,
      amount: 0,
      price: 0,
      localizedVehicleFeatureName,
      svgIconBase64: 'mdi-wheelchair-accessibility',
      showIcon: true,
    };
    selectedFeatures.push(wheelchairPlace);
  }
  store.commit('booking/setFeatures', selectedFeatures);
}

function setComfortType(newValue: string) {
  const {
    vehicleCategoryId,
    vehicleFeatures,
    maxSpecialSeatCapacity,
    localizedName,
  } = getVehicleCategories.value.find((category: any) => category.vehicleCategoryId === newValue);
  store.commit('booking/setVehicleCategoryId', vehicleCategoryId);
  store.commit('booking/setVehicleCategoryLocalizedName', localizedName);
  emit('clearBookingRequestError');
  setVehicleFeatures(vehicleFeatures, maxSpecialSeatCapacity);
}
</script>

<style scoped lang="scss">
</style>
